var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{class:_vm.type=='fail'?'fail message-box':'message-box'},[_c('p',[_c('img',{attrs:{"src":_vm.type=='fail'?_vm.failUrl:_vm.successUrl}}),_vm._v(_vm._s(_vm.message))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }